module.exports = __webpack_public_path__ + "static/media/cropped-jetson-logo-transparent.9b2ef08d.png";